module.exports = __webpack_public_path__ + "img/order_num.f14a67e0.png";